const getStatus = (score, target) => {
  let status = '';
  if (target < 6.66) {
    if (score < 6.66) {
      status = 'meets';
    } else if (score >= 6.66) {
      status = 'over';
    }
  } else if (target >= 6.66 && target < 13.33) {
    if (score >= 6.66 && score < 13.33) {
      status = 'meets';
    } else if (score > 13.33) {
      status = 'over';
    } else {
      status = 'under';
    }
  } else if (target >= 13.33) {
    if (score >= 13.33) {
      status = 'meets';
    } else {
      status = 'under';
    }
  }
  return status;
};

export const getLookAndFeelIcon = (score, target) => {
  const status = getStatus(score, target);
  switch (status) {
    case 'meets':
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-meets.svg?v=1714038225';
    case 'under':
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-falls-short.svg?v=1714038189';
    case 'over':
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-exceeds.svg?v=1714038244';
    default:
      return 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-falls-short.svg?v=1714038189';
  }
};

export const getlookFeelPerformance = (score, target) => {
  const status = getStatus(score, target);
  return status;
};
